import { gql } from '@apollo/client';

export const updateStationLog = gql`
  mutation updateStationLog($input: StationLogInput) {
    updateStationLog(input: $input) {
      id
      date
      reasonId
      message
      fixSolution
      unitHours
      createdAt
      createdBy
      deletedAt
      updatedAt
      updater
      Reason {
        id
        reason
      }
    }
  }
`;
